import { Component, Input, OnInit } from '@angular/core';


@Component({
    selector: 'app-weighing',
    templateUrl: './weighing.component.html',
    styleUrls: ['./weighing.component.scss'],
    standalone: false
})
export class WeighingComponent {//extends LuggageWeighingComponent implements OnInit  {
  @Input() weight = 0; 
  @Input() bagLimit = 0;
  @Input() currentBag;
  @Input() maxWeight;


  ngOnInit(): void {
    console.log("[currentBag]", this.currentBag);
    
  }
  
  
  

}
